import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
	name: string;
	kana: string;
	prev: string;
	next: string;
	alphabet: string;
};

const INITIAL_STATE: State = {
	name: '東京',
	kana: 'とうきょう',
	prev: '神田',
	next: '有楽町',
	alphabet: 'Tokyo',
};

export const appSlice = createSlice({
	name: 'app',
	initialState: INITIAL_STATE,
	reducers: {
		saveName: (state, action: PayloadAction<string>) => {
			state.name = action.payload;
		},
		saveKana: (state, action: PayloadAction<string>) => {
			state.kana = action.payload;
		},
		savePrev: (state, action: PayloadAction<string>) => {
			state.prev = action.payload;
		},
		saveNext: (state, action: PayloadAction<string>) => {
			state.next = action.payload;
		},
		saveAlphabet: (state, action: PayloadAction<string>) => {
			state.alphabet = action.payload;
		},
	},
});
